(function () {
  'use strict';
  var KEY = 'ornatecSchedule';
  var T = window.ornT || {};

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    render();
  }
  function inList(url) {
    return load().some(function (x) { return x.url === url; });
  }
  function add(title, url) {
    var list = load();
    if (!list.some(function (x) { return x.url === url; })) {
      list.push({ title: title, url: url });
      save(list);
    }
    setOpen(true);
  }
  function remove(url) {
    save(load().filter(function (x) { return x.url !== url; }));
  }

  var tray, panel, isOpen = false;

  function setOpen(open) {
    isOpen = open;
    if (panel) panel.classList.toggle('is-open', open);
    if (tray) tray.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function scheduleText() {
    return load().map(function (x) { return '- ' + x.title; }).join('\n');
  }

  function render() {
    var list = load();
    if (!tray) return;
    tray.querySelector('[data-orsch-count]').textContent = String(list.length);
    tray.classList.toggle('has-items', list.length > 0);
    var ul = panel.querySelector('[data-orsch-list]');
    ul.innerHTML = '';
    if (list.length === 0) {
      var empty = document.createElement('p');
      empty.className = 'orsch-empty';
      empty.textContent = T.sched_empty || 'No species added yet. Use "Add to Schedule" on any species reference.';
      ul.appendChild(empty);
    }
    list.forEach(function (item) {
      var li = document.createElement('div');
      li.className = 'orsch-item';
      var a = document.createElement('a');
      a.href = item.url;
      a.textContent = item.title;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'orsch-remove';
      x.setAttribute('aria-label', (T.sched_remove_item || 'Remove {title}').replace('{title}', item.title));
      x.textContent = '×';
      x.addEventListener('click', function () { remove(item.url); });
      li.appendChild(a);
      li.appendChild(x);
      ul.appendChild(li);
    });
    document.querySelectorAll('[data-orsch-add]').forEach(function (btn) {
      var added = inList(btn.getAttribute('data-orsch-url'));
      btn.classList.toggle('is-added', added);
      var label = btn.getAttribute('data-orsch-label') || T.sched_add || 'Add to Schedule';
      btn.textContent = added ? (T.sched_on_schedule || 'On Schedule ✓') : label;
    });
  }

  function buildTray() {
    tray = document.createElement('button');
    tray.type = 'button';
    tray.className = 'orsch-tray';
    tray.setAttribute('aria-expanded', 'false');
    tray.innerHTML = '<span class="orsch-tray__label">' + (T.sched_tray_label || 'Schedule') + '</span><span class="orsch-tray__count" data-orsch-count>0</span>';
    tray.addEventListener('click', function () { setOpen(!isOpen); });

    panel = document.createElement('div');
    panel.className = 'orsch-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', T.sched_panel_title || 'Your plant schedule');
    panel.innerHTML =
      '<div class="orsch-panel__head"><strong>' + (T.sched_panel_title || 'Your plant schedule') + '</strong><button type="button" class="orsch-close" aria-label="' + (T.sched_close || 'Close') + '">×</button></div>' +
      '<div class="orsch-panel__list" data-orsch-list></div>' +
      '<div class="orsch-panel__actions">' +
      '<a class="or5-button orsch-send" href="/pages/contact-us?from_schedule=1#ornatec-project-enquiry">' + (T.sched_send || 'Send This Schedule') + '</a>' +
      '<button type="button" class="orsch-secondary" data-orsch-copy>' + (T.sched_copy || 'Copy list') + '</button>' +
      '<button type="button" class="orsch-secondary" data-orsch-clear>' + (T.sched_clear || 'Clear') + '</button>' +
      '</div>' +
      '<p class="orsch-hint">' + (T.sched_hint || 'Your list is saved in this browser and loads into the enquiry form automatically.') + '</p>';
    panel.querySelector('.orsch-close').addEventListener('click', function () { setOpen(false); });
    panel.querySelector('[data-orsch-clear]').addEventListener('click', function () {
      if (confirm(T.sched_clear_confirm || 'Clear all species from your schedule?')) save([]);
    });
    panel.querySelector('[data-orsch-copy]').addEventListener('click', function (e) {
      var txt = scheduleText();
      if (navigator.clipboard && txt) {
        navigator.clipboard.writeText(txt).then(function () {
          e.target.textContent = T.sched_copied || 'Copied ✓';
          setTimeout(function () { e.target.textContent = T.sched_copy || 'Copy list'; }, 1600);
        });
      }
    });
    document.body.appendChild(tray);
    document.body.appendChild(panel);
  }

  function prefillContact() {
    var textarea = document.getElementById('Or5Message') || document.querySelector('textarea[name="contact[body]"]');
    if (!textarea) return;
    var form = textarea.closest('form');
    if (!form) return;
    var list = load();
    if (list.length === 0) return;
    var block = document.createElement('div');
    block.className = 'orsch-contact-summary';
    block.innerHTML = '<strong>' + (T.sched_contact_summary || 'Species on your schedule ({count})').replace('{count}', String(list.length)) + '</strong>';
    var wrap = document.createElement('div');
    wrap.className = 'orsch-chips';
    list.forEach(function (item) {
      var chip = document.createElement('span');
      chip.className = 'orsch-chip';
      chip.textContent = item.title;
      wrap.appendChild(chip);
    });
    block.appendChild(wrap);
    var field = textarea.closest('.or3-field');
    if (field && field.parentNode) field.parentNode.insertBefore(block, field);
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'contact[Schedule list]';
    hidden.value = list.map(function (x) { return x.title; }).join('; ');
    form.appendChild(hidden);
    if (!textarea.value) {
      textarea.value = (T.sched_prefill_heading || 'Species schedule:') + '\n' + scheduleText() + '\n\n' + (T.sched_prefill_prompt || 'Quantities, sizes and destination:') + '\n';
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-orsch-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var url = btn.getAttribute('data-orsch-url');
    if (inList(url)) { remove(url); } else { add(btn.getAttribute('data-orsch-title'), url); }
  });

  function init() {
    buildTray();
    render();
    if (location.pathname.indexOf('contact-us') !== -1) prefillContact();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
